import {useEffect} from 'react';

// Calls onOutside on a mousedown outside ref while active, e.g. to close a menu.
const useOutsideClick = (ref, onOutside, active) => {
  useEffect(() => {
    if (!active) return undefined;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [ref, onOutside, active]);
};

export default useOutsideClick;
